export default function BulkOrderFillMenuIcon(props) {
  return (
    <svg
      viewBox="-2 -2 28 28"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.11111 13C7.80556 13 7.54398 12.8912 7.32639 12.6736C7.1088 12.456 7 12.1944 7 11.8889V4.11111C7 3.80556 7.1088 3.54398 7.32639 3.32639C7.54398 3.1088 7.80556 3 8.11111 3H15.8889C16.1944 3 16.456 3.1088 16.6736 3.32639C16.8912 3.54398 17 3.80556 17 4.11111V11.8889C17 12.1944 16.8912 12.456 16.6736 12.6736C16.456 12.8912 16.1944 13 15.8889 13H8.11111ZM10 8L12 7.5L14 8V5.02826L12 5H11L10 5.02826V8Z"
        fill="currentColor"
      />
      <path
        d="M4.11111 21C3.80556 21 3.54398 20.8912 3.32639 20.6736C3.1088 20.456 3 20.1944 3 19.8889V12.1111C3 11.8056 3.1088 11.544 3.32639 11.3264C3.54398 11.1088 3.80556 11 4.11111 11H11.8889C12.1944 11 12.456 11.1088 12.6736 11.3264C12.8912 11.544 13 11.8056 13 12.1111V19.8889C13 20.1944 12.8912 20.456 12.6736 20.6736C12.456 20.8912 12.1944 21 11.8889 21H4.11111ZM6 16L8 15.5L10 16V13.0283L8 13H7L6 13.0283V16Z"
        fill="currentColor"
      />
      <path
        d="M12.1111 21C11.8056 21 11.544 20.8912 11.3264 20.6736C11.1088 20.456 11 20.1944 11 19.8889V12.1111C11 11.8056 11.1088 11.544 11.3264 11.3264C11.544 11.1088 11.8056 11 12.1111 11H19.8889C20.1944 11 20.456 11.1088 20.6736 11.3264C20.8912 11.544 21 11.8056 21 12.1111V19.8889C21 20.1944 20.8912 20.456 20.6736 20.6736C20.456 20.8912 20.1944 21 19.8889 21H12.1111ZM14 16L16 15.5L18 16V13.0283L16 13H15L14 13.0283V16Z"
        fill="currentColor"
      />
    </svg>
  );
}
